/* template */
<template><div class="mpx-root-view"><es-overlay :show="(visible)" position="fade"/><es-popup :value="visible" mpxModelEvent="input" @mpxModel='__model("visible", $event, ["value"], undefined)' :overlay="(false)" position="bottom" closeable @close="closePopup"><div class="main"><mpx-image mode="aspectFit" src="https://img-hxy021.didistatic.com/static/starimg/img/d8LYVTcyVg1689839655760.png" class="title-bac"></mpx-image><div class="title">提前支付，无需等待</div><div class="tips"><div v-for="(tip, index) in (formatTips)" :key="tip.index" class="tip"><div class="icon"></div><div><span v-for="(item, index) in (tip)" :class="({highlight:item.highlight})">{{item.value}}</span></div></div></div><div class="footer"><es-button @click="onAction('wait')" :custom-class='["prepay-btn"].join(" ")'>再等一会</es-button><es-button @click="onAction('pay')" :custom-class='["prepay-btn active"].join(" ")'>立即支付</es-button></div></div></es-popup></div></template>

/* styles */
<style lang="stylus" scoped mpxStyleOptions='{"mid":"m0afd4815"}'>
.main
  padding-bottom 84px
  border-radius 12px 12px 0 0
  overflow hidden
  background linear-gradient(180deg, #D9EBFF 0%, #FFFFFF 26%), #FFFFFF
  text-align center
  .title-bac
    width 80px
    height 48px
    margin 25px 10px 0 0
  .title
    font-size 18px
    color #000000
  .tips
    padding 12px
    border-radius 8px
    background linear-gradient(90deg, #E6F1FF 0%, rgba(244,249,255,0.41) 100%)
    margin 15px 16px 32px
    color #333
    font-size 12px
    line-height 24px
    text-align left 
    .tip
      display flex
      align-items flex-start
      .icon
        background-image url('https://img-hxy021.didistatic.com/static/starimg/img/tI9Ya6b8Q21689839356871.png')
        background-position center
        background-repeat no-repeat
        background-size contain
        width 12px
        height 12px
        margin 6px 8px 0 0
        flex none
      .highlight
        color #1473FF
  .footer
    height 84px
    width 100%
    position fixed
    bottom 0
    padding 16px 21px 0
    box-sizing border-box
    box-shadow 0px -2px 10px 0px rgba(0, 0, 0, 0.04)
    background-color #fff
    display flex
    align-items flex-start
    justify-content space-between
    .prepay-btn
      border-radius 8px
      background-color #F0F0F0
      color #333
      font-size 16px
      border none
      &.active
        color #fff
        background-color #FF7F41
    .es-button + .es-button
      margin-left 12px
</style>

/* json */
/* script */
<script>
  import processOption, { getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  const wxsModules = {}
  global.currentModuleId = "m0afd4815"
  global.currentSrcMode = "wx"
  /** script content **/
  require("./prepay-popup.mpx.js?isComponent&outputPath=components%2Fprepay-popup0afd4815%2Findex!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./prepay-popup.mpx?ctorType=component&index=0&isComponent&mpx&outputPath=components%2Fprepay-popup0afd4815%2Findex&type=script")
  const currentOption = global.__mpxOptionsMap["m0afd4815"]
  export default processOption(
    currentOption,
    "component",
    "",
    "components/prepay-popup0afd4815/index",
    {},
    // @ts-ignore
    {},
    // @ts-ignore
    {'es-button':getComponent(require("../../../../node_modules/@didi/es-mpx-ui/lib/button/index.mpx?isComponent&outputPath=components%2Findexbc68cb48%2Findex")),'es-popup':getComponent(require("../../../../node_modules/@didi/es-mpx-ui/lib/popup/index.mpx?isComponent&outputPath=components%2Findex9216a4d4%2Findex")),'es-overlay':getComponent(require("../../../../node_modules/@didi/es-mpx-ui/lib/overlay/index.mpx?isComponent&outputPath=components%2Findex3774078c%2Findex")),'mpx-image':getComponent(require("@mpxjs/webpack-plugin/lib/runtime/components/web/mpx-image.vue?isComponent"), { __mpxBuiltIn: true })},
    undefined,
    {},
    undefined,
    getWxsMixin(wxsModules)
  )
</script>
